import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Flame, Heart, Shield, Zap, Lock, AlertTriangle } from 'lucide-react';

const iconMap = {
  'incendie': Flame,
  'secourisme': Heart,
  'prevention-securite': Shield,
  'habilitation-electrique': Zap,
  'securite-privee': Lock,
  'risque-attentat': AlertTriangle
};

const FormationCard = ({ category, type = 'prestations' }) => {
  const Icon = iconMap[category.slug] || Shield;
  const baseUrl = type === 'prestations' ? '/prestations' : '/formations';
  
  return (
    <Link 
      to={`${baseUrl}/${category.slug}`}
      className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
    >
      {/* Image with Overlay */}
      <div className="relative h-80 overflow-hidden">
        <img 
          src={`${category.image}?w=600&h=800&fit=crop`}
          alt={category.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
        
        {/* Red accent bar */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-red-600"></div>
        
        {/* Icon */}
        <div className="absolute top-6 left-6 bg-white rounded-full p-4 shadow-lg group-hover:bg-red-600 transition-colors duration-300">
          <Icon size={32} className="text-red-600 group-hover:text-white transition-colors duration-300" />
        </div>
      </div>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
        <h3 className="text-2xl font-bold mb-2 uppercase tracking-wide">
          {category.title}
        </h3>
        <p className="text-gray-200 text-sm mb-4">
          {category.formationsCount} formation{category.formationsCount > 1 ? 's' : ''}
        </p>
        <div className="flex items-center gap-2 text-white font-semibold group-hover:gap-4 transition-all duration-300">
          <span className="border-2 border-white px-5 py-2 rounded-md group-hover:bg-white group-hover:text-red-600 transition-all duration-300">
            VOIR LES FORMATIONS
          </span>
          <ArrowRight size={20} className="group-hover:translate-x-2 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};

export default FormationCard;